const PT_BR: string[] = [
  "eh",
  "ehh",
  "ahn",
  "ahm",
  "ahhh",
  "ah",
  "hm",
  "hmm",
  "uhm",
  "uhmm",
  "humm",
  "mm",
  "mmm",
  "éé",
  "ééé",
  "tipo",
  "né",
  "então",
];

const EN_US: string[] = [
  "um",
  "uh",
  "uhh",
  "uhm",
  "uhmm",
  "er",
  "erm",
  "ah",
  "ahh",
  "hmm",
  "mm",
  "mmm",
  "like",
  "basically",
];

const ES_ES: string[] = [
  "eh",
  "ehh",
  "ehm",
  "em",
  "ah",
  "ahh",
  "hm",
  "hmm",
  "mm",
  "mmm",
  "este",
  "pues",
];

const LISTS: Record<string, string[]> = {
  "pt-BR": PT_BR,
  "en-US": EN_US,
  "es-ES": ES_ES,
};

export function normalizeForFillerMatch(word: string): string {
  return word
    .toLowerCase()
    .replace(/[\p{P}\p{S}]/gu, "")
    .trim();
}

export function getFillerWordSet(language: string | null | undefined): Set<string> {
  const list = language ? LISTS[language] : null;
  if (!list) return new Set();
  return new Set(list.map(normalizeForFillerMatch));
}

export function isFillerWordSupported(language: string | null | undefined): boolean {
  return !!language && language in LISTS;
}
